import type { SelectionEvents } from '@tilelist/application/ports/SelectionEvents.ts';
import type { Selection } from './NexusSelection.browser.ts';

export function createSelectionEvents(selection: Selection): SelectionEvents {
    return {
        current: () => selection.currentSelection(),
        onUpdate: (handler) => selection.onUpdate(handler),
        navigate: (state, source) => selection.navigate(state, source),
    };
}
